import React, { useContext } from "react";

import Profile from "../Pages/Profile/Profile.jsx";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Admin from "../Pages/AdminPages/Admin/Admin.jsx";
import ViewResults from "../Pages/AdminPages/ViewResults/ViewResults.jsx";
import Interviu from "../Pages/Interviu/Interviu.jsx";
import TesteTehnice from "../Pages/TesteTehnice/TesteTehnice.jsx";
import LandingPage from "../Pages/LandingPage/LandingPage.jsx";
import Register from "../Pages/Register/Register.jsx";

import { RootContext } from "../context/RootProvider.jsx";

import Wrapper from "../Components/Wrapper/Wrapper.jsx";
import AdminWrapper from "../Components/Wrapper/AdminWrapper.jsx";
import LoadTests from "../Pages/AdminPages/LoadTests/LoadTests.jsx";
import UserTestContainer from "../Pages/TesteTehnice/UserTestContainer/UserTestContainer.jsx";
import ViewBooked from "../Pages/AdminPages/ViewBooked/ViewBooked.jsx";
import TestFinished from "../Pages/TesteTehnice/TestFinished/TestFinished.jsx";
import StopRegister from "../Pages/StopRegister/StopRegister.jsx";
import TestTehnic from "../Pages/TesteTehnice/TesteTehnice.jsx";
import CreareInterviu from "../Pages/AdminPages/CreareInterviu/CreareInterviu.jsx";
import StopInterviews from "../Pages/StopInterviews/StopInterviews.jsx";

function Paths() {
  const rootContext = useContext(RootContext);

  const user = rootContext.user;
  const isUserAdmin = rootContext.isUserAdmin;
  console.log(user?.isProfileComplete)
  console.log(user?.isProfileComplete)

  if (user?.isProfileComplete) {
    return (
      <>
        <Router>
          <Routes>
            <Route path="/" element={<Wrapper />}>
              <Route index element={<Profile />} />
              <Route path="/profile" element={<Profile />} />
               <Route path="/interviu" element={<StopInterviews />} />  
              {/* <Route path="/test-tehnic" element={<TestTehnic/>} /> */}
              <Route path="/landing" element={<LandingPage />} />
            </Route>

            <Route
              path="teste-tehnice/:userID/:testID"
              element={<UserTestContainer />}
            />
            <Route
              path="teste-tehnice/:userID/:testID/completat"
              element={<TestFinished />}
            />


            {isUserAdmin && (
              <Route path="/admin" element={<AdminWrapper />}>
                <Route index element={<Admin />} />
                <Route path="home" element ={<Admin/>}></Route>
                {/* <Route path="view-results" element={<ViewResults />} /> */}
                <Route path="view-booked" element={<ViewBooked />} />
                <Route path="create-interview" element={<CreareInterviu />} />
                {/* <Route path="load-tests" element={<LoadTests />} /> */}
              </Route>
            )}
          </Routes>
        </Router>
      </>
    );
  } else {
    return (
      <>
        <Router>
          <Routes>
            <Route path="/landing" element={<LandingPage />} />
             {/* <Route path="/register" element={<Register />} />  */}
             <Route path="/profile" element={<StopRegister />} />
            <Route path="/*" element={<LandingPage />} />
          </Routes>
        </Router>
      </>
    );
  }
}

export default Paths;
